import React from 'react';
import { makeStyles, Box } from '@material-ui/core';
import { Typography } from '@swagup-com/components';
import { shoppingExperienceColors } from '../constants';

const useStyles = makeStyles(() => ({
  root: {
    position: 'fixed',
    bottom: 0,
    left: 80,
    width: 200,
    height: 45,
    backgroundColor: shoppingExperienceColors.primary,
    color: shoppingExperienceColors.white,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0px 0px 4px 0px rgba(0,0,0,0.12), 0px 12px 24px 2px rgba(0,0,0,0.06)',
    zIndex: 1300,
    cursor: 'pointer',
    borderTopLeftRadius: 30,
    borderTopRightRadius: 30,
    border: 'none'
  },
  label: {
    marginTop: '5px'
  }
}));

const BottomFAB = ({ onClick }) => {
  const classes = useStyles();

  return (
    <Box component="button" className={classes.root} onClick={onClick}>
      <Typography variant="body2SemiBoldInter" style={{ color: shoppingExperienceColors.white, marginTop: '7px' }}>
        Your Swag Pack
      </Typography>
    </Box>
  );
};

export default BottomFAB;
